import React from 'react'

export default function Radiation() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M256 303.1c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 22.4-48 48 21.5 48 48 48zM213.6 188L142.7 74.71c-10.2-16.3-32.8-20.4-47.45-7.96-44.94 38.1-76.19 91.82-85.17 152.8-2.814 19.15 12.59 36.25 31.93 36.25h133.8c-.01-28.6 15.19-53.5 37.79-67.8zM416.8 66.75c-14.67-12.44-37.21-8.338-47.41 7.965L298.4 188c22.6 14.3 37.8 39.2 37.8 67.8H470c19.34 0 34.74-17.13 31.93-36.26C492.9 158.6 461.7 104.8 416.8 66.75zM298.4 323.5c-12.3 7.7-26.8 12.4-42.4 12.4s-30.1-4.701-42.4-12.4l-70.9 113.4c-10.14 16.21-4.16 38.2 13.32 45.95C186.6 496.4 220.4 504 256 504s69.42-7.611 100-21.18c17.48-7.752 23.46-29.74 13.32-45.95L298.4 323.5z"></path>
        </svg>
    )
}
